import {
    useGetSuccessionPlanDocsListQuery,
    useUploadSuccessionPlanMutation,
    useDeleteSuccessionPlanDocsItemMutation,
  } from "../../redux/services/successionPlanAPI";
  

  export const useDocumentsAPI = (type: "successionPlan" | "growthPlan") => {
    switch (type) {
      case "successionPlan":
        return {
          useGetDocs: useGetSuccessionPlanDocsListQuery,
          useUploadDoc: useUploadSuccessionPlanMutation,
          useDeleteDoc: useDeleteSuccessionPlanDocsItemMutation,
        };
  
      case "growthPlan":
        // replace this API's once real API's are ready
        return {
          useGetDocs: useGetSuccessionPlanDocsListQuery,
          useUploadDoc: useUploadSuccessionPlanMutation,
          useDeleteDoc: useDeleteSuccessionPlanDocsItemMutation,
        };
  
      default:
        throw new Error("Unsupported API type");
    }
  };
  